export default __webpack_public_path__ + "static/media/salad.9284fab7.png";